<template>
  <div>
    <div>
      <Form :model="searchResourceData" inline>
        <FormItem label="">
          <!-- 云平台下拉框 -->
          <Select
            v-model="searchResourceData.accountType"
            filterable
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountType')
            "
            @on-change="changeResource"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="">
          <!-- 资源下拉框 根据云平台显示的 -->
          <Select
            v-model="searchResourceData.resourceType"
            filterable
            @on-change="searchResourceType"
            placeholder="请选择资源"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in resourceTypeList"
              :disabled="item.disabled"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 资源子集 根据上面的资源父级查的 -->
        <FormItem label="" v-if="this.resourceChildTypeList.length > 0">
          <Select
            v-model="searchResourceData.resourceChildType"
            filterable
            @on-change="searchResourceChildType()"
            placeholder="请选择资源"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in resourceChildTypeList"
              :disabled="item.disabled"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>

      <!-- AWS-存储桶 -->
      <resource-index
        v-if="showBucket"
        ref="BucketRef"
        :searchList="searchBucketList"
        :searchData="searchBucketData"
        :columns="BucketColumns"
        :tableData="BucketTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'Bucket')"
        @changePageNum="item => changePageNum(item, 'Bucket')"
        @changePageSize="item => changePageSize(item, 'Bucket')"
      ></resource-index>
      <add-resource
        v-if="addBucketVisible"
        ref="addBucketRef"
        :addResourceList="addResourceBucketList"
        :addResourceData="addResourceBucketData"
        :addColums="BucketAddColumns"
        :addTableData="BucketAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'Bucket')"
      ></add-resource>

      <!-- Aliyun-日志服务 -->
      <resource-index
        v-if="showLogService"
        ref="LogServiceRef"
        :searchList="searchLogServiceList"
        :searchData="searchLogServiceData"
        :columns="LogServiceColumns"
        :tableData="LogServiceTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'LogService')"
        @changePageNum="item => changePageNum(item, 'LogService')"
        @changePageSize="item => changePageSize(item, 'LogService')"
      ></resource-index>
      <add-resource
        v-if="addLogServiceVisible"
        ref="addLogServiceRef"
        :addResourceList="addResourceLogServiceList"
        :addResourceData="addResourceLogServiceData"
        :addColums="LogServiceAddColumns"
        :addTableData="LogServiceAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'LogService')"
      ></add-resource>

      <!-- AWS-弹性负载均衡 -->
      <resource-index
        v-if="showSLB"
        ref="SLBRef"
        :searchList="searchSLBList"
        :searchData="searchSLBData"
        :columns="SLBColumns"
        :tableData="SLBTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'SLB')"
        @changePageNum="item => changePageNum(item, 'SLB')"
        @changePageSize="item => changePageSize(item, 'SLB')"
      ></resource-index>
      <add-resource
        v-if="addSLBVisible"
        ref="addSLBRef"
        :addResourceList="addResourceSLBList"
        :addResourceData="addResourceSLBData"
        :addColums="SLBAddColumns"
        :addTableData="SLBAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'SLB')"
      ></add-resource>

      <!-- AWS-nat网关 -->
      <resource-index
        v-if="showNatGateway"
        ref="NatGatewayRef"
        :searchList="searchNatGatewayList"
        :searchData="searchNatGatewayData"
        :columns="NatGatewayColumns"
        :tableData="NatGatewayTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'NatGateway')"
        @changePageNum="item => changePageNum(item, 'NatGateway')"
        @changePageSize="item => changePageSize(item, 'NatGateway')"
      ></resource-index>
      <add-resource
        v-if="addNatGatewayVisible"
        ref="addNatGatewayRef"
        :addResourceList="addResourceNatGatewayList"
        :addResourceData="addResourceNatGatewayData"
        :addColums="NatGatewayAddColumns"
        :addTableData="NatGatewayAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'NatGateway')"
      ></add-resource>

      <!-- AWS-redshift -->
      <resource-index
        v-if="showRedshift"
        ref="RedshiftRef"
        :searchList="searchRedshiftList"
        :searchData="searchRedshiftData"
        :columns="RedshiftColumns"
        :tableData="RedshiftTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'Redshift')"
        @changePageNum="item => changePageNum(item, 'Redshift')"
        @changePageSize="item => changePageSize(item, 'Redshift')"
      ></resource-index>
      <add-resource
        v-if="addRedshiftVisible"
        ref="addRedshiftRef"
        :addResourceList="addResourceRedshiftList"
        :addResourceData="addResourceRedshiftData"
        :addColums="RedshiftAddColumns"
        :addTableData="RedshiftAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'Redshift')"
      ></add-resource>

      <!-- AWS-Elasticsearch -->
      <resource-index
        v-if="showElasticsearch"
        ref="ElasticsearchRef"
        :searchList="searchElasticsearchList"
        :searchData="searchElasticsearchData"
        :columns="ElasticsearchColumns"
        :tableData="ElasticsearchTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'Elasticsearch')"
        @changePageNum="item => changePageNum(item, 'Elasticsearch')"
        @changePageSize="item => changePageSize(item, 'Elasticsearch')"
      ></resource-index>
      <add-resource
        v-if="addElasticsearchVisible"
        ref="addElasticsearchRef"
        :addResourceList="addResourceElasticsearchList"
        :addResourceData="addResourceElasticsearchData"
        :addColums="ElasticsearchAddColumns"
        :addTableData="ElasticsearchAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'Elasticsearch')"
      ></add-resource>

      <!-- AWS-备份计划 -->
      <resource-index
        v-if="showBackUp"
        ref="BackUpRef"
        :searchList="searchBackUpList"
        :searchData="searchBackUpData"
        :columns="BackUpColumns"
        :tableData="BackUpTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'BackUp')"
        @changePageNum="item => changePageNum(item, 'BackUp')"
        @changePageSize="item => changePageSize(item, 'BackUp')"
      ></resource-index>
      <add-resource
        v-if="addBackUpVisible"
        ref="addBackUpRef"
        :addResourceList="addResourceBackUpList"
        :addResourceData="addResourceBackUpData"
        :addColums="BackUpAddColumns"
        :addTableData="BackUpAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        @submit="(rule, item) => submitData(rule, item, 'BackUp')"
      ></add-resource>

      <add-instances
        ref="instanceChild"
        v-if="showCalculationExample"
        :getAccountType="getAccountType"
      ></add-instances>

      <add-volumes
        ref="volumeChild"
        v-if="showVolumes"
        :getAccountType="getAccountType"
      ></add-volumes>
      <add-databases
        ref="databaseChild"
        v-if="showDatabases"
        :type="getAccountType"
      ></add-databases>
      <add-storage-gateways
        ref="storageGatewayChild"
        v-if="showStorageGateways"
        :getAccountType="getAccountType"
      ></add-storage-gateways>
      <add-elasti-cache
        ref="elastiCacheChild"
        :getAccountType="getAccountType"
        v-if="showRedis"
      ></add-elasti-cache>

      <!-- 防火墙 -->
      <resource-index
        v-if="showFirewall"
        ref="FirewallRef"
        :searchList="searchFirewallList"
        :searchData="searchFirewallData"
        :columns="FirewallColumns"
        :tableData="FirewallTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'Firewall')"
        @changePageNum="item => changePageNum(item, 'Firewall')"
        @changePageSize="item => changePageSize(item, 'Firewall')"
      ></resource-index>
      <add-resource
        v-if="addFirewallVisible"
        ref="addFirewallRef"
        :addResourceList="addResourceFirewallList"
        :addResourceData="addResourceFirewallData"
        :addColums="FirewallAddColumns"
        :addTableData="FirewallAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        :listLoading="listLoading"
        @submit="(rule, item) => submitData(rule, item, 'Firewall')"
      ></add-resource>

      <!-- CEN -->
      <resource-index
        v-if="showCEN"
        ref="CENRef"
        :searchList="searchCENList"
        :searchData="searchCENData"
        :columns="CENColumns"
        :tableData="CENTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'CEN')"
        @changePageNum="item => changePageNum(item, 'CEN')"
        @changePageSize="item => changePageSize(item, 'CEN')"
      ></resource-index>
      <add-resource
        v-if="addCENVisible"
        ref="addCENRef"
        :addResourceList="addResourceCENList"
        :addResourceData="addResourceCENData"
        :addColums="CENAddColumns"
        :addTableData="CENAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        :listLoading="listLoading"
        @submit="(rule, item) => submitData(rule, item, 'CEN')"
      ></add-resource>

      <!-- 弹性ip -->
      <resource-index
        v-if="showElasticIp"
        ref="ElasticIpRef"
        :searchList="searchElasticIpList"
        :searchData="searchElasticIpData"
        :columns="ElasticIpColumns"
        :tableData="ElasticIpTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'ElasticIp')"
        @changePageNum="item => changePageNum(item, 'ElasticIp')"
        @changePageSize="item => changePageSize(item, 'ElasticIp')"
      ></resource-index>
      <add-resource
        v-if="addElasticIpVisible"
        ref="addElasticIpRef"
        :addResourceList="addResourceElasticIpList"
        :addResourceData="addResourceElasticIpData"
        :addColums="ElasticIpAddColumns"
        :addTableData="ElasticIpAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        :listLoading="listLoading"
        @submit="(rule, item) => submitData(rule, item, 'ElasticIp')"
      ></add-resource>

      <!-- Autoscaling -->
      <resource-index
        v-if="showAutoscaling"
        ref="AutoscalingRef"
        :searchList="searchAutoscalingList"
        :searchData="searchAutoscalingData"
        :columns="AutoscalingColumns"
        :tableData="AutoscalingTableData"
        :addBtnDisabled="addBtnDisabled"
        :listLoading="listLoading"
        @handleDel="item => handleDel(item, 'Autoscaling')"
        @changePageNum="item => changePageNum(item, 'Autoscaling')"
        @changePageSize="item => changePageSize(item, 'Autoscaling')"
      ></resource-index>
      <add-resource
        v-if="addAutoscalingVisible"
        ref="addAutoscalingRef"
        :addResourceList="addResourceAutoscalingList"
        :addResourceData="addResourceAutoscalingData"
        :addColums="AutoscalingAddColumns"
        :addTableData="AutoscalingAddTableData"
        :rules="rules"
        :getAccountType="getAccountType"
        :getAccountId="getAccountId"
        :listLoading="listLoading"
        @submit="(rule, item) => submitData(rule, item, 'Autoscaling')"
      ></add-resource>

      <Modal v-model="delModal" width="360" :mask-closable="false">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
        </p>
        <div style="text-align:center">
          <p>
            {{ $t("alarms.common.sureDelete") }} {{ Name }}
            {{ $t("alarms.common.what") }}?
          </p>
        </div>
        <div slot="footer">
          <Button
            type="error"
            size="large"
            long
            @click="deleteResource"
            :disabled="isDisable"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import ResourceIndex from "@/components/configuration/permissions_configuration_management/resource_permission/resource/ResourceIndex";
import AddResource from "@/components/configuration/permissions_configuration_management/resource_permission/resource/AddResource";
import { getCookie } from "../../../../../utils/cookieUtil";
import AddInstances from "../../resource_permission/AddInstances";
import AddDatabases from "../../resource_permission/AddDatabases";
import AddVolumes from "../../resource_permission/AddVolumes";
import AddAccount from "../../resource_permission/AddAccount";
import AddUsers from "../../resource_permission/AddUsers";
import AddWorkSpace from "../../resource_permission/AddWorkSpace";
import AddStorageGateways from "../../resource_permission/AddStorageGateways";
import AddElastiCache from "../../resource_permission/AddElastiCache";
export default {
  components: {
    ResourceIndex,
    AddResource,
    AddInstances,
    AddDatabases,
    AddUsers,
    AddVolumes,
    AddAccount,
    AddWorkSpace,
    AddStorageGateways,
    AddElastiCache
  },
  data() {
    return {
      delModal: false,
      addBucketVisible: false,
      addLogServiceVisible: false,
      addSLBVisible: false,
      addNatGatewayVisible: false,
      addRedshiftVisible: false,
      addElasticsearchVisible: false,
      addBackUpVisible: false,
      addFirewallVisible: false,
      addCENVisible: false,
      addElasticIpVisible: false,
      addAutoscalingVisible: false,

      addInstanceVisible: false,
      addBtnDisabled: true,

      getAccountType: 0,
      getAccountId: 0,
      Name: "",
      isDisable: false,
      getItem: "",
      getType: "",
      searchResourceData: {
        accountType: "",
        resourceType: "",
        resourceChildType: ""
      },
      accountTypeList: [],
      resourceTypeList: [],
      resourceChildTypeList: [],

      showBucket: false,
      showLogService: false,
      showSLB: false,
      showNatGateway: false,
      showRedshift: false,
      showElasticsearch: false,
      showBackUp: false,
      showCalculationExample: false,
      showVolumes: false,
      showDatabases: false,
      showStorageGateways: false,
      showRedis: false,
      showFirewall: false,
      showCEN: false,
      showElasticIp: false,
      showAutoscaling: false,
      listLoading: false,
      // aws-存储桶
      searchBucketList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "Bucket",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按存储桶名称查询",
          prop: "name",
          type: "input",
          flag: "Bucket",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加存储桶",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "Bucket",
          handle: row => this.showAddResource(row)
        }
      ],
      searchBucketData: {
        accountName: "",
        groupId: "",
        accountType: "",
        bucketName: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceBucketList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "Bucket",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "Bucket",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "Bucket",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceBucketData: {
        accountIds: [],
        region: "",
        title: "添加存储桶"
      },
      BucketTableData: [],
      BucketColumns: [
        {
          title: this.$t("RAM.AWS.StorageBin.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.binName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.bucketStorage"),
          key: "bucketStorage"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.launchTime"),
          key: "creationDateString"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.establishPerson"),
          key: "displayName"
        },
        {
          title: this.$t("alarms.disk.encrypted"),
          key: "defaultEncryption"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      BucketAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },

        {
          title: this.$t("alarms.objectStorage.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.binName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.StorageBin.bucketStorage"),
          key: "bucketStorage"
        },
        {
          title: this.$t("alarms.disk.encrypted"),
          key: "defaultEncryption"
        }
      ],
      BucketAddTableData: [],

      // Aliyun-日志服务
      searchLogServiceList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "LogService",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按日志库名称查询",
          prop: "projectName",
          type: "input",
          flag: "LogService",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加sls",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "LogService",
          handle: row => this.showAddResource(row)
        }
      ],
      searchLogServiceData: {
        accountName: "",
        groupId: "",
        projectName: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceLogServiceList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "LogService",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "LogService",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "LogService",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceLogServiceData: {
        accountIds: [],
        region: "",
        title: "添加sls"
      },
      LogServiceTableData: [],
      LogServiceColumns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.Sls.accountTypeName"),
          key: "accountTypeName"
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.NatGateway.state"),
          key: "state"
        },
        {
          title: this.$t("RAM.ALI.Sls.logstoreName"),
          key: "logstoreName"
        },
        {
          title: this.$t("RAM.ALI.Sls.projectName"),
          key: "projectName"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      LogServiceAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.NatGateway.state"),
          key: "state"
        },
        {
          title: this.$t("RAM.ALI.Sls.logstoreName"),
          key: "logstoreName"
        },
        {
          title: this.$t("RAM.ALI.Sls.projectName"),
          key: "projectName"
        }
      ],
      LogServiceAddTableData: [],

      // AWS- 负载均衡
      searchSLBList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "SLB",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按负载均衡ID查询",
          prop: "loadbalancerId",
          type: "input",
          flag: "SLB",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加弹性负载均衡",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "SLB",
          handle: row => this.showAddResource(row)
        }
      ],
      searchSLBData: {
        accountName: "",
        loadbalancerId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceSLBList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "SLB",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "SLB",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "SLB",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceSLBData: {
        accountIds: [],
        region: "",
        title: "添加弹性负载均衡"
      },
      SLBTableData: [],
      SLBColumns: [
        {
          title: this.$t("alarms.network.loadBalancing.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.network.loadBalancing.loadbalancerId"),
          key: "loadbalancerId"
        },
        {
          title: this.$t("alarms.network.loadBalancing.DNSName"),
          key: "dnsName"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: this.$t("alarms.network.loadBalancing.LBType"),
          key: "loadbalancerType"
        },
        {
          title: this.$t("alarms.network.loadBalancing.status"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.network.loadBalancing.region"),
          key: "region"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      SLBAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("alarms.network.loadBalancing.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.network.loadBalancing.DNSName"),
          key: "dnsName"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: this.$t("alarms.network.loadBalancing.LBType"),
          key: "loadbalancerType"
        },
        {
          title: this.$t("alarms.network.loadBalancing.status"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.network.loadBalancing.region"),
          key: "region"
        }
      ],
      SLBAddTableData: [],

      // AWS- nat网关
      searchNatGatewayList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "NatGateway",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按NAT网关ID查询",
          prop: "natGatewayId",
          type: "input",
          flag: "NatGateway",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加Nat网关",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "NatGateway",
          handle: row => this.showAddResource(row)
        }
      ],
      searchNatGatewayData: {
        accountName: "",
        natGatewayId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceNatGatewayList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "NatGateway",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "NatGateway",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "NatGateway",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceNatGatewayData: {
        accountIds: [],
        region: "",
        title: "添加Nat网关"
      },
      NatGatewayTableData: [],
      NatGatewayColumns: [
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "accountIdString"
        },
        {
          title: "区域",
          key: "region"
        },
        {
          title: "网关名称",
          key: "name"
        },
        {
          title: "NAT网关ID",
          key: "natGatewayId"
        },
        {
          title: "状态",
          key: "state"
        },
        {
          title: "弹性IP地址",
          key: "publicIp"
        },
        {
          title: "私有IP地址",
          key: "privateIp"
        },
        {
          title: "网络接口ID",
          key: "networkInterfaceId"
        },
        {
          title: "VPC",
          key: "vpcId"
        },
        {
          title: "子网",
          key: "subnetId"
        },
        {
          title: "创建时间",
          key: "createTime"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      NatGatewayAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "区域",
          key: "region"
        },
        {
          title: "网关名称",
          key: "name"
        },
        {
          title: "NAT网关ID",
          key: "natGatewayId"
        },
        {
          title: "状态",
          key: "state"
        },
        {
          title: "弹性IP地址",
          key: "publicIp"
        },
        {
          title: "私有IP地址",
          key: "privateIp"
        },
        {
          title: "网络接口ID",
          key: "networkInterfaceId"
        },
        {
          title: "VPC",
          key: "vpcId"
        },
        {
          title: "子网",
          key: "subnetId"
        }
      ],
      NatGatewayAddTableData: [],

      // AWS- Redshift
      searchRedshiftList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "Redshift",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按集群名称查询",
          prop: "clusterIdentifier",
          type: "input",
          flag: "Redshift",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加Redshift",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "Redshift",
          handle: row => this.showAddResource(row)
        }
      ],
      searchRedshiftData: {
        accountName: "",
        clusterIdentifier: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceRedshiftList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "Redshift",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "Redshift",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "Redshift",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceRedshiftData: {
        accountIds: [],
        region: "",
        title: "添加Redshift"
      },
      RedshiftTableData: [],
      RedshiftColumns: [
        {
          title: this.$t("RAM.AWS.Redshift.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Redshift.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterName"),
          key: "clusterIdentifier"
        },
        {
          title: "FQDN",
          key: "address"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterStatus"),
          key: "clusterStatus"
        },
        {
          title: this.$t("RAM.AWS.Redshift.databaseStatus"),
          key: "status"
        },
        {
          title: this.$t("RAM.AWS.Redshift.releaseStatus"),
          key: "releaseStatus"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      RedshiftAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterName"),
          key: "clusterIdentifier"
        },
        {
          title: "FQDN",
          key: "address"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterStatus"),
          key: "clusterStatus"
        },
        {
          title: this.$t("RAM.AWS.Redshift.databaseStatus"),
          key: "status"
        },
        {
          title: this.$t("RAM.AWS.Redshift.releaseStatus"),
          key: "releaseStatus"
        }
      ],
      RedshiftAddTableData: [],

      // AWS- Elasticsearch
      searchElasticsearchList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "Elasticsearch",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按域名称查询",
          prop: "domainName",
          type: "input",
          flag: "Elasticsearch",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加Elasticsearch",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "Elasticsearch",
          handle: row => this.showAddResource(row)
        }
      ],
      searchElasticsearchData: {
        accountName: "",
        domainName: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceElasticsearchList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "Elasticsearch",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "Elasticsearch",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "Elasticsearch",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceElasticsearchData: {
        accountIds: [],
        region: "",
        title: "添加Elasticsearch"
      },
      ElasticsearchTableData: [],
      ElasticsearchColumns: [
        {
          title: this.$t("RAM.AWS.Elasticsearch.accountName"),
          minWidth: 150,
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.accountID"),
          minWidth: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.domainName"),
          minWidth: 150,
          key: "domainName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.elasticsearchVersion"),
          minWidth: 150,
          key: "elasticsearchVersion"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceCount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeType"),
          minWidth: 150,
          key: "volumeType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeSize"),
          minWidth: 150,
          key: "volumeSize"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions",
          minWidth: 100
        }
      ],
      ElasticsearchAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.domainName"),
          minWidth: 150,
          key: "domainName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.elasticsearchVersion"),
          minWidth: 150,
          key: "elasticsearchVersion"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceCount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeType"),
          minWidth: 150,
          key: "volumeType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeSize"),
          minWidth: 150,
          key: "volumeSize"
        }
      ],
      ElasticsearchAddTableData: [],

      // AWS- 备份计划
      searchBackUpList: [
        {
          name: this.$t(
            "permission_configuration_management.group.checkByAccountName"
          ),
          prop: "accountName",
          type: "input",
          flag: "BackUp",
          change: (item, value) => this.getName(item, value)
        },
        {
          name: "按备份计划ID查询",
          prop: "backupPlanId",
          type: "input",
          flag: "BackUp",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "添加BackUp",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "BackUp",
          handle: row => this.showAddResource(row)
        }
      ],
      searchBackUpData: {
        accountName: "",
        backupPlanId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceBackUpList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "BackUp",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "BackUp",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "BackUp",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceBackUpData: {
        accountIds: [],
        region: "",
        title: "添加备份计划"
      },
      BackUpTableData: [],
      BackUpColumns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanId"),
          key: "backupPlanId"
        },

        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanName"),
          key: "backupPlanName"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.lastExecutionDate"),
          key: "lastExecutionDate"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.creationDate"),
          key: "creationDate"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions",
          minWidth: 100
        }
      ],
      BackUpAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanId"),
          key: "backupPlanId"
        },

        {
          title: this.$t("RAM.AWS.Backup.Plan.backupPlanName"),
          key: "backupPlanName"
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.lastExecutionDate"),
          key: "lastExecutionDate"
        }
      ],
      BackUpAddTableData: [],

      // 防火墙
      searchFirewallList: [
        {
          name: this.$t("RAM.common.filterByAccountName"),
          prop: "accountName",
          type: "input",
          flag: "Firewall",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: this.$t("RAM.common.QuerybyInstanceID"),
          prop: "instanceId",
          type: "input",
          flag: "Firewall",
          change: (item, value) => this.getInstanceId(item, value)
        },
        {
          name: "添加Firewall",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "Firewall",
          handle: row => this.showAddResource(row)
        }
      ],
      searchFirewallData: {
        accountName: "",
        instanceId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceFirewallList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "Firewall",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "Firewall",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "Firewall",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceFirewallData: {
        accountIds: [],
        region: "",
        title: "添加Firewall"
      },
      FirewallTableData: [],
      FirewallColumns: [
        {
          title: this.$t("RAM.ALI.Waf.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.Waf.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.Waf.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Waf.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.ALI.Waf.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.ALI.Waf.versionName"),
          key: "versionName"
        },

        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions",
          minWidth: 100
        }
      ],
      FirewallAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.ALI.Waf.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.Waf.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.Waf.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Waf.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.ALI.Waf.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.ALI.Waf.versionName"),
          key: "versionName"
        }
      ],
      FirewallAddTableData: [],

      // CEN
      searchCENList: [
        {
          name: this.$t("RAM.common.filterByAccountName"),
          prop: "accountName",
          type: "input",
          flag: "CEN",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: this.$t("RAM.common.QuerybyInstanceID"),
          prop: "instanceId",
          type: "input",
          flag: "CEN",
          change: (item, value) => this.getInstanceId(item, value)
        },
        {
          name: "添加CEN",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "CEN",
          handle: row => this.showAddResource(row)
        }
      ],
      searchCENData: {
        accountName: "",
        instanceId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceCENList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "CEN",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "CEN",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "CEN",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceCENData: {
        accountIds: [],
        region: "",
        title: "添加CEN"
      },
      CENTableData: [],
      CENColumns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },

        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Cen.cenId"),
          key: "cenId"
        },
        {
          title: this.$t("RAM.ALI.Cen.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.Cen.description"),
          key: "description"
        },
        {
          title: this.$t("RAM.ALI.Cen.status"),
          key: "status"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions",
          minWidth: 100
        }
      ],
      CENAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Cen.cenId"),
          key: "cenId"
        },
        {
          title: this.$t("RAM.ALI.Cen.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.Cen.description"),
          key: "description"
        },
        {
          title: this.$t("RAM.ALI.Cen.status"),
          key: "status"
        },
        {
          title: this.$t("RAM.ALI.Cen.ipv6Level"),
          key: "ipv6Level"
        },
        {
          title: this.$t("RAM.ALI.Cen.protectionLevel"),
          key: "protectionLevel"
        },
        {
          title: this.$t("RAM.ALI.Cen.resourceGroupId"),
          key: "resourceGroupId"
        }
      ],
      CENAddTableData: [],

      // ElasticIp
      searchElasticIpList: [
        {
          name: this.$t("RAM.common.filterByAccountName"),
          prop: "accountName",
          type: "input",
          flag: "ElasticIp",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "按弹性IP查询",
          prop: "instanceId",
          type: "input",
          flag: "ElasticIp",
          change: (item, value) => this.getInstanceId(item, value)
        },
        {
          name: "添加ElasticIp",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "ElasticIp",
          handle: row => this.showAddResource(row)
        }
      ],
      searchElasticIpData: {
        accountName: "",
        instanceId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceElasticIpList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "ElasticIp",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "ElasticIp",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "ElasticIp",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceElasticIpData: {
        accountIds: [],
        region: "",
        title: "添加ElasticIp"
      },
      ElasticIpTableData: [],
      ElasticIpColumns: [
        {
          title: this.$t("RAM.AWS.ElasticIP.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.title"),
          key: "publicIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.allocatedID"),
          key: "allocationId"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.AttachedInstance"),
          key: "instanceId"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions",
          minWidth: 100
        }
      ],
      ElasticIpAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.title"),
          key: "publicIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.allocatedID"),
          key: "allocationId"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.AttachedInstance"),
          key: "instanceId"
        }
      ],
      ElasticIpAddTableData: [],

      // Autoscaling
      searchAutoscalingList: [
        {
          name: this.$t("RAM.common.filterByAccountName"),
          prop: "accountName",
          type: "input",
          flag: "Autoscaling",
          change: (item, value) => this.getAccountName(item, value)
        },
        {
          name: "按弹性伸缩组ID查询",
          prop: "instanceId",
          type: "input",
          flag: "Autoscaling",
          change: (item, value) => this.getInstanceId(item, value)
        },
        {
          name: "添加Autoscaling",
          type: "button",
          style: "primary",
          size: "mini",
          flag: "Autoscaling",
          handle: row => this.showAddResource(row)
        }
      ],
      searchAutoscalingData: {
        accountName: "",
        instanceId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addResourceAutoscalingList: [
        {
          name: "账户",
          prop: "accountIds",
          type: "select",
          flag: "Autoscaling",
          change: (item, value) => this.handleChangeAccount(item, value)
        },
        {
          name: "区域",
          prop: "region",
          type: "select",
          flag: "Autoscaling",
          change: (item, value) => this.handleChangeRegion(item, value)
        },
        {
          btnName: "查询",
          type: "button",
          style: "primary",
          flag: "Autoscaling",
          handle: (item, value) => this.getAddData(item, value)
        }
      ],
      addResourceAutoscalingData: {
        accountIds: [],
        region: "",
        title: "添加Autoscaling"
      },
      AutoscalingTableData: [],
      AutoscalingColumns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.accountType"),
          key: "accountType"
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.scalingGroupId"),
          key: "scalingGroupId"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.scalingGroupName"),
          key: "scalingGroupName"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.groupType"),
          key: "groupType"
        },

        {
          title: this.$t("RAM.ALI.NatGateway.vpcId"),
          key: "vpcId"
        },

        {
          title: this.$t("RAM.ALI.AutoScaling.totalInstanceCount"),
          key: "totalInstanceCount"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.lifecycleState"),
          key: "lifecycleState"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.minSize"),
          key: "minSize"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.maxSize"),
          key: "maxSize"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.groupModificationTime"),
          key: "groupModificationTime"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.isActive"),
          key: "isActive"
        },

        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "actions"
        }
      ],
      AutoscalingAddColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.accountType"),
          key: "accountType"
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.scalingGroupId"),
          key: "scalingGroupId"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.scalingGroupName"),
          key: "scalingGroupName"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.groupType"),
          key: "groupType"
        },

        {
          title: this.$t("RAM.ALI.NatGateway.vpcId"),
          key: "vpcId"
        },

        {
          title: this.$t("RAM.ALI.AutoScaling.totalInstanceCount"),
          key: "totalInstanceCount"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.lifecycleState"),
          key: "lifecycleState"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.minSize"),
          key: "minSize"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.maxSize"),
          key: "maxSize"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.groupModificationTime"),
          key: "groupModificationTime"
        },
        {
          title: this.$t("RAM.ALI.AutoScaling.isActive"),
          key: "isActive"
        }
      ],
      AutoscalingAddTableData: [],
      rules: {
        accountIds: [
          {
            required: true,
            message: "账户为必填项",
            trigger: "blur"
          }
        ],
        region: [
          {
            required: true,
            message: "区域为必填项",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 请求资源接口
    changeResource(data) {
      this.$api.resourcePermis
        .queryResourceTypeBox("accountType", data)
        .then(res => {
          this.resourceTypeList = res.data;
          this.getAccountType = this.searchResourceData.accountType;
        });
      this.searchResourceData.resourceChildType = "";
      this.searchResourceData.resourceType = "";
      this.addBtnDisabled = false;
      this.showBackUp = false;
      this.showBucket = false;
      this.showLogService = false;
      this.showNatGateway = false;
      this.showRedshift = false;
      this.showElasticsearch = false;
      this.showSLB = false;
      this.showCalculationExample = false;
      this.showVolumes = false;
      this.showDatabases = false;
      this.showStorageGateways = false;
      this.showRedis = false;
      this.showFirewall = false;
      this.showAutoscaling = false;
      this.showElasticIp = false;
      this.showCEN = false;
      this.searchBucketData.accountName = "";
      this.searchBucketData.bucketName = "";

      this.searchSLBData.accountName = "";
      this.searchSLBData.loadbalancerId = "";

      this.searchLogServiceData.accountName = "";
      this.searchLogServiceData.projectName = "";

      this.searchNatGatewayData.accountName = "";
      this.searchNatGatewayData.natGatewayId = "";

      this.searchRedshiftData.accountName = "";
      this.searchRedshiftData.clusterIdentifier = "";

      this.searchElasticsearchData.accountName = "";
      this.searchElasticsearchData.domainName = "";

      this.searchBackUpData.accountName = "";
      this.searchBackUpData.backupPlanId = "";

      this.searchFirewallData.accountName = "";
      this.searchFirewallData.instanceId = "";

      this.searchCENData.accountName = "";
      this.searchCENData.instanceId = "";

      this.searchElasticIpData.accountName = "";
      this.searchElasticIpData.instanceId = "";

      this.searchAutoscalingData.accountName = "";
      this.searchAutoscalingData.instanceId = "";
    },
    // 请求二级资源接口
    searchResourceType(data) {
      this.$api.resourcePermis
        .querySubResourceTypeBox({
          accountType: this.searchResourceData.accountType,
          path: this.searchResourceData.resourceType
        })
        .then(res => {
          this.resourceChildTypeList = res.data;
          this.searchBucketData.accountName = "";
          this.searchBucketData.bucketName = "";

          this.searchSLBData.accountName = "";
          this.searchSLBData.loadbalancerId = "";

          this.searchLogServiceData.accountName = "";
          this.searchLogServiceData.projectName = "";

          this.searchNatGatewayData.accountName = "";
          this.searchNatGatewayData.natGatewayId = "";

          this.searchRedshiftData.accountName = "";
          this.searchRedshiftData.clusterIdentifier = "";

          this.searchElasticsearchData.accountName = "";
          this.searchElasticsearchData.domainName = "";

          this.searchBackUpData.accountName = "";
          this.searchBackUpData.backupPlanId = "";

          this.searchFirewallData.accountName = "";
          this.searchFirewallData.instanceId = "";

          this.searchCENData.accountName = "";
          this.searchCENData.instanceId = "";

          this.searchElasticIpData.accountName = "";
          this.searchElasticIpData.instanceId = "";

          this.searchAutoscalingData.accountName = "";
          this.searchAutoscalingData.instanceId = "";
          this.showResourceData();
        });
    },
    searchResourceChildType() {
      if (
        this.searchResourceData.resourceChildType ==
        "/resourceConfigurationManagement/aws/backup/serverlessReplications"
      ) {
        // AWS- backup - 备份计划
        this.showBackUp = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getBackUpData();
      } else if (
        this.searchResourceData.resourceChildType ==
        "/resourceConfigurationManagement/aws/elastiCacheResource/redis"
      ) {
        // redis
        this.showRedis = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.$nextTick(() => {
          this.$refs.elastiCacheChild.queryCloudPlatforms();
          this.$refs.elastiCacheChild.pagingQuery();
        });
      } else {
        this.showRedis = false;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
      }
    },
    // 切换资源时 显示对应数据并请求分页查询接口
    showResourceData() {
      if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/simpleStorageServiceResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/oss" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/cloudStorageGcp"
      ) {
        // AWS-存储桶
        this.showBucket = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBackUp = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.searchBucketData.bucketName = "";
        this.getBucketData();
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/ali/sls"
      ) {
        // Aliyun-应用程序服务/sls
        this.showLogService = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBucket = false;
        this.showBackUp = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.getLogServiceData();
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/elasticLoadBalancingResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/elasticLoadBalancingResourceAli" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/azure/loadBalance" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/elasticLoadBalancingResourceGcp"
      ) {
        // AWS- 弹性负载均衡
        this.showSLB = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBucket = false;
        this.showBackUp = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.getSLBData();
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/natGatewayResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/natGateway"
      ) {
        // AWS- nat网关
        this.showNatGateway = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBucket = false;
        this.showBackUp = false;
        this.showLogService = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.getNatGatewayData();
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/aws/redshiftResource"
      ) {
        // AWS- Redshift
        this.showRedshift = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.getRedshiftData();
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/aws/elasticsearchResource"
      ) {
        // AWS- Elasticsearch
        this.showElasticsearch = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.getElasticsearchData();
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/elasticComputeCloudResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/elasticComputeCloudResourceAli" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/elasticComputeCloudResourceGcp" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/azure/elasticComputeCloudResourceAzure"
      ) {
        // 计算实例
        this.showCalculationExample = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.$nextTick(() => {
          this.$refs.instanceChild.queryInstancesByGroupId();
          this.$refs.instanceChild.queryCloudPlatforms();
        });
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/elasticBlockStoreResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/elasticBlockStoreResourceAli" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/elasticBlockStoreResourceGcp" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/azure/elasticBlockStoreResourceAzure"
      ) {
        // 磁盘
        this.showVolumes = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.$nextTick(() => {
          this.$refs.volumeChild.queryCloudPlatforms();
          this.$refs.volumeChild.queryVolumesByGroupId();
        });
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/relationalDatabaseServiceResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/relationalDatabaseServiceResourceAli" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/azure/relationalDatabaseServiceResourceAzure" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/relationalDatabaseServiceResourceGcp"
      ) {
        // 数据库
        this.showDatabases = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.showVolumes = false;
        this.$nextTick(() => {
          this.$refs.databaseChild.getAccountType();
          this.$refs.databaseChild.queryDatabaseEngines();
          this.$refs.databaseChild.queryDatabasesByGroupId();
        });
      } else if (
        this.searchResourceData.resourceType == "/monitor/storageGatewayMonitor"
      ) {
        // 存储网关
        this.showStorageGateways = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showRedis = false;
        this.showVolumes = false;
        this.$nextTick(() => {
          this.$refs.storageGatewayChild.queryCloudPlatforms();
          this.$refs.storageGatewayChild.queryStorageGatewaysByGroupId();
        });
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/redis" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/gcp/redisGcp"
      ) {
        // redis
        this.showRedis = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.$nextTick(() => {
          this.$refs.elastiCacheChild.queryCloudPlatforms();
          this.$refs.elastiCacheChild.pagingQuery();
        });
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/ali/waf"
      ) {
        // web应用防火墙
        this.showFirewall = true;
        this.showCEN = false;
        this.showElasticIp = false;
        this.showAutoscaling = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getFirewallData();
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/ali/cen"
      ) {
        // CEN
        this.showCEN = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showFirewall = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getCENData();
      } else if (
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/aws/elasticResource" ||
        this.searchResourceData.resourceType ==
          "/resourceConfigurationManagement/ali/elasticResourceIp"
      ) {
        // ElasticIp
        this.showElasticIp = true;
        this.showAutoscaling = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getElasticIpData();
      } else if (
        this.searchResourceData.resourceType ==
        "/resourceConfigurationManagement/ali/autoScaling"
      ) {
        // Autoscaling
        this.showAutoscaling = true;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getAutoscalingData();
      } else if (
        this.searchResourceData.resourceChildType ==
        "/resourceConfigurationManagement/aws/backup/serverlessReplications"
      ) {
        // AWS- backup - 备份计划
        this.showBackUp = true;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
        this.showFirewall = false;
        this.showRedis = false;
        this.showElasticsearch = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showVolumes = false;
        this.getBackUpData();
      } else if (
        this.searchResourceData.resourceChildType ==
        "/resourceConfigurationManagement/aws/elastiCacheResource/redis"
      ) {
        this.searchResourceData.resourceChildType = "";
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.showFirewall = false;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
      } else {
        this.showBackUp = false;
        this.showBucket = false;
        this.showLogService = false;
        this.showNatGateway = false;
        this.showRedshift = false;
        this.showElasticsearch = false;
        this.showSLB = false;
        this.showCalculationExample = false;
        this.showVolumes = false;
        this.showDatabases = false;
        this.showStorageGateways = false;
        this.showRedis = false;
        this.showFirewall = false;
        this.showAutoscaling = false;
        this.showElasticIp = false;
        this.showCEN = false;
      }
    },
    // 存储桶查询方法
    getBucketData() {
      this.listLoading = true;
      this.searchBucketData.groupId = this.$route.query.id;
      this.searchBucketData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchBucketData.groupId,
        accountType: this.searchBucketData.accountType,
        accountName: this.searchBucketData.accountName,
        bucketName: this.searchBucketData.bucketName,
        pageNum: this.searchBucketData.pageNum,
        pageSize: this.searchBucketData.pageSize
      };
      this.$api.resourcePermis.queryBucketsByGroupId(_data).then(res => {
        this.BucketTableData = res.data.records;
        this.searchBucketData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // aliyun-sls 查询方法
    getLogServiceData() {
      this.listLoading = true;
      this.searchLogServiceData.groupId = this.$route.query.id;
      this.searchLogServiceData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchLogServiceData.groupId,
        accountType: this.searchLogServiceData.accountType,
        accountName: this.searchLogServiceData.accountName,
        projectName: this.searchLogServiceData.projectName,
        pageNum: this.searchLogServiceData.pageNum,
        pageSize: this.searchLogServiceData.pageSize
      };
      this.$api.resourcePermis.queryLogsByGroupId(_data).then(res => {
        this.LogServiceTableData = res.data.records;
        this.searchLogServiceData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS-负载均衡 查询方法
    getSLBData() {
      this.listLoading = true;
      this.searchSLBData.groupId = this.$route.query.id;
      this.searchSLBData.accountType = this.searchResourceData.accountType;
      let _data = {
        accountName: this.searchSLBData.accountName,
        loadbalancerId: this.searchSLBData.loadbalancerId,
        groupId: this.searchSLBData.groupId,
        accountType: this.searchSLBData.accountType,
        pageNum: this.searchSLBData.pageNum,
        pageSize: this.searchSLBData.pageSize
      };
      this.$api.resourcePermis.queryLoadBalancersByGroupId(_data).then(res => {
        this.SLBTableData = res.data.records;
        this.searchSLBData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS-nat网关 查询方法
    getNatGatewayData() {
      this.listLoading = true;
      this.searchNatGatewayData.groupId = this.$route.query.id;
      this.searchNatGatewayData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchNatGatewayData.groupId,
        accountType: this.searchNatGatewayData.accountType,
        accountName: this.searchNatGatewayData.accountName,
        natGatewayId: this.searchNatGatewayData.natGatewayId,
        pageNum: this.searchNatGatewayData.pageNum,
        pageSize: this.searchNatGatewayData.pageSize
      };
      this.$api.resourcePermis.queryNatGatewayByGroupId(_data).then(res => {
        this.NatGatewayTableData = res.data.records;
        this.searchNatGatewayData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- Redshift 查询方法
    getRedshiftData() {
      this.listLoading = true;
      this.searchRedshiftData.groupId = this.$route.query.id;
      this.searchRedshiftData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchRedshiftData.groupId,
        clusterIdentifier: this.searchRedshiftData.clusterIdentifier,
        accountName: this.searchRedshiftData.accountName,
        accountType: this.searchRedshiftData.accountType,
        pageNum: this.searchRedshiftData.pageNum,
        pageSize: this.searchRedshiftData.pageSize
      };
      this.$api.resourcePermis.queryRedshiftsByGroupId(_data).then(res => {
        this.RedshiftTableData = res.data.records;
        this.searchRedshiftData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- Elasticsearch 查询方法
    getElasticsearchData() {
      this.listLoading = true;
      this.searchElasticsearchData.groupId = this.$route.query.id;
      this.searchElasticsearchData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchElasticsearchData.groupId,
        accountName: this.searchElasticsearchData.accountName,
        domainName: this.searchElasticsearchData.domainName,
        accountType: this.searchElasticsearchData.accountType,
        pageNum: this.searchElasticsearchData.pageNum,
        pageSize: this.searchElasticsearchData.pageSize
      };
      this.$api.resourcePermis.queryEsByGroupId(_data).then(res => {
        this.ElasticsearchTableData = res.data.records;
        this.searchElasticsearchData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- BackUp 查询方法
    getBackUpData() {
      this.listLoading = true;
      this.searchBackUpData.groupId = this.$route.query.id;
      this.searchBackUpData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchBackUpData.groupId,
        accountName: this.searchBackUpData.accountName,
        backupPlanId: this.searchBackUpData.backupPlanId,
        accountType: this.searchBackUpData.accountType,
        pageNum: this.searchBackUpData.pageNum,
        pageSize: this.searchBackUpData.pageSize
      };
      this.$api.resourcePermis.queryBackupPlanByGroupId(_data).then(res => {
        this.BackUpTableData = res.data.records;
        this.searchBackUpData.total = res.data.total;
        this.listLoading = false;
      });
    },

    // AWS- 防火墙 查询方法
    getFirewallData() {
      this.listLoading = true;
      this.searchFirewallData.groupId = this.$route.query.id;
      this.searchFirewallData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchFirewallData.groupId,
        instanceId: this.searchFirewallData.instanceId,
        accountName: this.searchFirewallData.accountName,
        accountType: this.searchFirewallData.accountType,
        pageNum: this.searchFirewallData.pageNum,
        pageSize: this.searchFirewallData.pageSize
      };
      this.$api.resourcePermis.queryWafsByGroupId(_data).then(res => {
        this.FirewallTableData = res.data.records;
        this.searchFirewallData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- CEN 查询方法
    getCENData() {
      this.listLoading = true;
      this.searchCENData.groupId = this.$route.query.id;
      this.searchCENData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchCENData.groupId,
        instanceId: this.searchCENData.instanceId,
        accountName: this.searchCENData.accountName,
        accountType: this.searchCENData.accountType,
        pageNum: this.searchCENData.pageNum,
        pageSize: this.searchCENData.pageSize
      };
      this.$api.resourcePermis.queryAlicensByGroupId(_data).then(res => {
        this.CENTableData = res.data.records;
        this.searchCENData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- ElasticIp 查询方法
    getElasticIpData() {
      this.listLoading = true;
      this.searchElasticIpData.groupId = this.$route.query.id;
      this.searchElasticIpData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchElasticIpData.groupId,
        instanceId: this.searchElasticIpData.instanceId,
        accountName: this.searchElasticIpData.accountName,
        accountType: this.searchElasticIpData.accountType,
        pageNum: this.searchElasticIpData.pageNum,
        pageSize: this.searchElasticIpData.pageSize
      };
      this.$api.resourcePermis.queryEipsByGroupId(_data).then(res => {
        this.ElasticIpTableData = res.data.records;
        this.searchElasticIpData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // AWS- Autoscaling 查询方法
    getAutoscalingData() {
      this.listLoading = true;
      this.searchAutoscalingData.groupId = this.$route.query.id;
      this.searchAutoscalingData.accountType = this.searchResourceData.accountType;
      let _data = {
        groupId: this.searchAutoscalingData.groupId,
        instanceId: this.searchAutoscalingData.instanceId,
        accountName: this.searchAutoscalingData.accountName,
        accountType: this.searchAutoscalingData.accountType,
        pageNum: this.searchAutoscalingData.pageNum,
        pageSize: this.searchAutoscalingData.pageSize
      };
      this.$api.resourcePermis.queryAutoscalingsByGroupId(_data).then(res => {
        this.AutoscalingTableData = res.data.records;
        this.searchAutoscalingData.total = res.data.total;
        this.listLoading = false;
      });
    },
    // 删除
    handleDel(item, type) {
      this.delModal = true;
      this.Name = item.name || item.accountName;
      this.getItem = item;
      this.getType = type;
    },
    deleteResource() {
      let item = this.getItem;
      let type = this.getType;
      this.isDisable = true;
      if (type == "Bucket") {
        let _data = { groupId: this.$route.query.id, bucketId: item.id };
        this.$api.resourcePermis.deleteByGroupIdAndBucketId(_data).then(res => {
          this.$Message.success("删除成功");
          this.getBucketData();
          this.isDisable = false;
          this.delModal = false;
        });
      } else if (type == "LogService") {
        let _data = { groupId: this.$route.query.id, logId: item.id };
        this.$api.resourcePermis.deleteByGroupIdAndLogId(_data).then(res => {
          this.$Message.success("删除成功");
          this.getLogServiceData();
          this.isDisable = false;
          this.delModal = false;
        });
      } else if (type == "SLB") {
        let _data = { groupId: this.$route.query.id, loadBalancerId: item.id };
        this.$api.resourcePermis
          .deleteByGroupIdAndLoadBalancerId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getSLBData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "NatGateway") {
        let _data = { groupId: this.$route.query.id, natGatewayId: item.id };
        this.$api.resourcePermis
          .deleteByGroupIdAndNatGatewayId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getNatGatewayData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "Redshift") {
        let _data = { groupId: this.$route.query.id, clusterId: item.id };
        this.$api.resourcePermis
          .deleteByGroupIdAndClusterId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getRedshiftData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "Elasticsearch") {
        let _data = { groupId: this.$route.query.id, esId: item.id };
        this.$api.resourcePermis.deleteByGroupIdAndEsId(_data).then(res => {
          this.$Message.success("删除成功");
          this.getElasticsearchData();
          this.isDisable = false;
          this.delModal = false;
        });
      } else if (type == "BackUp") {
        let _data = { groupId: this.$route.query.id, backupPlanId: item.id };
        this.$api.resourcePermis
          .deleteByGroupIdAndbackupPlanId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getBackUpData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "Firewall") {
        let _data = { groupId: this.$route.query.id, instanceId: item.id };
        this.$api.resourcePermis
          .deletefirewallByGroupIdAndInstanceId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getFirewallData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "CEN") {
        let _data = { groupId: this.$route.query.id, instanceId: item.id };
        this.$api.resourcePermis
          .deleteCENByGroupIdAndInstanceId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getCENData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "ElasticIp") {
        let _data = { groupId: this.$route.query.id, instanceId: item.id };
        this.$api.resourcePermis
          .deleteElasticIPByGroupIdAndInstanceId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getElasticIpData();
            this.isDisable = false;
            this.delModal = false;
          });
      } else if (type == "Autoscaling") {
        let _data = { groupId: this.$route.query.id, instanceId: item.id };
        this.$api.resourcePermis
          .deleteAutoscalingsByGroupIdAndInstanceId(_data)
          .then(res => {
            this.$Message.success("删除成功");
            this.getAutoscalingData();
            this.isDisable = false;
            this.delModal = false;
          });
      }
    },
    getName(item, value) {
      if (item.flag == "Bucket") {
        this.searchBucketData.accountName = value;
        this.getBucketData();
      } else if (item.flag == "SLB") {
        this.searchSLBData.accountName = value;
        this.getSLBData();
      } else if (item.flag == "LogService") {
        this.searchLogServiceData.accountName = value;
        this.getLogServiceData();
      } else if (item.flag == "NatGateway") {
        this.searchNatGatewayData.accountName = value;
        this.getNatGatewayData();
      } else if (item.flag == "Redshift") {
        this.searchRedshiftData.accountName = value;
        this.getRedshiftData();
      } else if (item.flag == "Elasticsearch") {
        this.searchElasticsearchData.accountName = value;
        this.getElasticsearchData();
      } else if (item.flag == "BackUp") {
        this.searchBackUpData.accountName = value;
        this.getBackUpData();
      } else {
        this.searchBucketData.accountName = "";
      }
    },
    // 根据查询条件-名称 查询接口
    getAccountName(item, value) {
      if (item.flag == "Bucket") {
        this.searchBucketData.bucketName = value;
        this.getBucketData();
      } else if (item.flag == "SLB") {
        this.searchSLBData.loadbalancerId = value;
        this.getSLBData();
      } else if (item.flag == "LogService") {
        this.searchLogServiceData.projectName = value;
        this.getLogServiceData();
      } else if (item.flag == "NatGateway") {
        this.searchNatGatewayData.natGatewayId = value;
        this.getNatGatewayData();
      } else if (item.flag == "Redshift") {
        this.searchRedshiftData.clusterIdentifier = value;
        this.getRedshiftData();
      } else if (item.flag == "Elasticsearch") {
        this.searchElasticsearchData.domainName = value;
        this.getElasticsearchData();
      } else if (item.flag == "BackUp") {
        this.searchBackUpData.backupPlanId = value;
        this.getBackUpData();
      } else if (item.flag == "Firewall") {
        this.searchFirewallData.accountName = value;
        this.getFirewallData();
      } else if (item.flag == "CEN") {
        this.searchCENData.accountName = value;
        this.getCENData();
      } else if (item.flag == "ElasticIp") {
        this.searchElasticIpData.accountName = value;
        this.getElasticIpData();
      } else if (item.flag == "Autoscaling") {
        this.searchAutoscalingData.accountName = value;
        this.getAutoscalingData();
      }
    },
    getInstanceId(item, value) {
      if (item.flag == "Firewall") {
        this.searchFirewallData.instanceId = value;
        this.getFirewallData();
      } else if (item.flag == "CEN") {
        this.searchCENData.instanceId = value;
        this.getCENData();
      } else if (item.flag == "ElasticIp") {
        this.searchElasticIpData.instanceId = value;
        this.getElasticIpData();
      } else if (item.flag == "Autoscaling") {
        this.searchAutoscalingData.instanceId = value;
        this.getAutoscalingData();
      }
    },
    // 点击添加按钮 显示添加弹窗
    showAddResource(row) {
      this.addResourceBucketData.accountIds = [];
      this.addResourceLogServiceData.accountIds = [];
      this.addResourceSLBData.accountIds = [];
      this.addResourceNatGatewayData.accountIds = [];
      this.addResourceRedshiftData.accountIds = [];
      this.addResourceElasticsearchData.accountIds = [];
      this.addResourceBackUpData.accountIds = [];
      this.addResourceFirewallData.accountIds = [];
      this.addResourceCENData.accountIds = [];
      this.addResourceElasticIpData.accountIds = [];
      this.addResourceAutoscalingData.accountIds = [];
      this.addResourceBucketData.region = "";
      this.addResourceLogServiceData.region = "";
      this.addResourceSLBData.region = "";
      this.addResourceNatGatewayData.region = "";
      this.addResourceRedshiftData.region = "";
      this.addResourceElasticsearchData.region = "";
      this.addResourceBackUpData.region = "";
      this.addResourceFirewallData.region = "";
      this.addResourceCENData.region = "";
      this.addResourceElasticIpData.region = "";
      this.addResourceAutoscalingData.region = "";
      this.BucketAddTableData = [];
      this.SLBAddTableData = [];
      this.LogServiceAddTableData = [];
      this.NatGatewayAddTableData = [];
      this.RedshiftAddTableData = [];
      this.ElasticsearchAddTableData = [];
      this.BackUpAddTableData = [];
      this.FirewallAddTableData = [];
      this.CENAddTableData = [];
      this.ElasticIpAddTableData = [];
      this.AutoscalingAddTableData = [];
      // 根据type显示资源对应弹窗
      if (row.flag == "Bucket") {
        this.addBucketVisible = true;
        this.$nextTick(() => {
          this.$refs.addBucketRef.resourceVisible = true;
          this.$refs.addBucketRef.getAccount();
        });
      } else if (row.flag == "LogService") {
        this.addLogServiceVisible = true;
        this.$nextTick(() => {
          this.$refs.addLogServiceRef.resourceVisible = true;
          this.$refs.addLogServiceRef.getAccount();
        });
      } else if (row.flag == "SLB") {
        this.addSLBVisible = true;
        this.$nextTick(() => {
          this.$refs.addSLBRef.resourceVisible = true;
          this.$refs.addSLBRef.getAccount();
        });
      } else if (row.flag == "NatGateway") {
        this.addNatGatewayVisible = true;
        this.$nextTick(() => {
          this.$refs.addNatGatewayRef.resourceVisible = true;
          this.$refs.addNatGatewayRef.getAccount();
        });
      } else if (row.flag == "Redshift") {
        this.addRedshiftVisible = true;
        this.$nextTick(() => {
          this.$refs.addRedshiftRef.resourceVisible = true;
          this.$refs.addRedshiftRef.getAccount();
        });
      } else if (row.flag == "Elasticsearch") {
        this.addElasticsearchVisible = true;
        this.$nextTick(() => {
          this.$refs.addElasticsearchRef.resourceVisible = true;
          this.$refs.addElasticsearchRef.getAccount();
        });
      } else if (row.flag == "BackUp") {
        this.addBackUpVisible = true;
        this.$nextTick(() => {
          this.$refs.addBackUpRef.resourceVisible = true;
          this.$refs.addBackUpRef.getAccount();
        });
      } else if (row.flag == "Firewall") {
        this.addFirewallVisible = true;
        this.$nextTick(() => {
          this.$refs.addFirewallRef.resourceVisible = true;
          this.$refs.addFirewallRef.getAccount();
        });
      } else if (row.flag == "CEN") {
        this.addCENVisible = true;
        this.$nextTick(() => {
          this.$refs.addCENRef.resourceVisible = true;
          this.$refs.addCENRef.getAccount();
        });
      } else if (row.flag == "ElasticIp") {
        this.addElasticIpVisible = true;
        this.$nextTick(() => {
          this.$refs.addElasticIpRef.resourceVisible = true;
          this.$refs.addElasticIpRef.getAccount();
        });
      } else if (row.flag == "Autoscaling") {
        this.addAutoscalingVisible = true;
        this.$nextTick(() => {
          this.$refs.addAutoscalingRef.resourceVisible = true;
          this.$refs.addAutoscalingRef.getAccount();
        });
      }
    },
    getEvent() {},
    // 更改当前第几页
    changePageNum(item, type) {
      if (type == "Bucket") {
        this.searchBucketData.pageNum = item;
        this.getBucketData();
      } else if (type == "LogService") {
        this.searchLogServiceData.pageNum = item;
        this.getLogServiceData();
      } else if (type == "SLB") {
        this.searchSLBData.pageNum = item;
        this.getSLBData();
      } else if (type == "NatGateway") {
        this.searchNatGatewayData.pageNum = item;
        this.getNatGatewayData();
      } else if (type == "Redshift") {
        this.searchRedshiftData.pageNum = item;
        this.getRedshiftData();
      } else if (type == "Elasticsearch") {
        this.searchElasticsearchData.pageNum = item;
        this.getElasticsearchData();
      } else if (type == "BackUp") {
        this.searchBackUpData.pageNum = item;
        this.getBackUpData();
      } else if (type == "Firewall") {
        this.searchFirewallData.pageNum = item;
        this.getFirewallData();
      } else if (type == "CEN") {
        this.searchCENData.pageNum = item;
        this.getCENData();
      } else if (type == "ElasticIp") {
        this.searchElasticIpData.pageNum = item;
        this.getElasticIpData();
      } else if (type == "Autoscaling") {
        this.searchAutoscalingData.pageNum = item;
        this.getAutoscalingData();
      }
    },
    // 更改每页显示条数
    changePageSize(item, type) {
      if (type == "Bucket") {
        this.searchBucketData.pageSize = item;
        this.getBucketData();
      } else if (type == "LogService") {
        this.searchLogServiceData.pageSize = item;
        this.getLogServiceData();
      } else if (type == "SLB") {
        this.searchSLBData.pageSize = item;
        this.getSLBData();
      } else if (type == "NatGateway") {
        this.searchNatGatewayData.pageSize = item;
        this.getNatGatewayData();
      } else if (type == "Redshift") {
        this.searchRedshiftData.pageSize = item;
        this.getRedshiftData();
      } else if (type == "Elasticsearch") {
        this.searchElasticsearchData.pageSize = item;
        this.getElasticsearchData();
      } else if (type == "BackUp") {
        this.searchBackUpData.pageSize = item;
        this.getBackUpData();
      } else if (type == "Firewall") {
        this.searchFirewallData.pageSize = item;
        this.getFirewallData();
      } else if (type == "CEN") {
        this.searchCENData.pageSize = item;
        this.getCENData();
      } else if (type == "ElasticIp") {
        this.searchElasticIpData.pageSize = item;
        this.getElasticIpData();
      } else if (type == "Autoscaling") {
        this.searchAutoscalingData.pageSize = item;
        this.getAutoscalingData();
      }
    },
    // 添加弹窗-点击确定
    submitData(rule, item, type) {
      if (type == "Bucket") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          bucketDTOS: item
        };
        this.$api.resourcePermis.createObjStorage(_data).then(res => {
          this.$Message.success("添加成功");
          this.addBucketVisible = false;
          this.getBucketData();
        });
      } else if (type == "LogService") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          logDTOS: item
        };
        this.$api.resourcePermis.createLogService(_data).then(res => {
          this.$Message.success("添加成功");
          this.addLogServiceVisible = false;
          this.getLogServiceData();
        });
      } else if (type == "SLB") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          loadBalancerDTOS: item
        };
        this.$api.resourcePermis.createLoadBalancerRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addSLBVisible = false;
          this.getSLBData();
        });
      } else if (type == "NatGateway") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          natGatewayDTOS: item
        };
        this.$api.resourcePermis.createNatGateway(_data).then(res => {
          this.$Message.success("添加成功");
          this.addNatGatewayVisible = false;
          this.getNatGatewayData();
        });
      } else if (type == "Redshift") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          clusterDTOS: item
        };
        this.$api.resourcePermis.createRedshiftRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addRedshiftVisible = false;
          this.getRedshiftData();
        });
      } else if (type == "Elasticsearch") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          esDTOS: item
        };
        this.$api.resourcePermis.createEsRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addElasticsearchVisible = false;
          this.getElasticsearchData();
        });
      } else if (type == "BackUp") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          backupPlanDTOS: item
        };
        this.$api.resourcePermis.createBackupPlanRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addBackUpVisible = false;
          this.getBackUpData();
        });
      } else if (type == "Firewall") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          resourceList: item
        };
        this.$api.resourcePermis.createWafRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addFirewallVisible = false;
          this.getFirewallData();
        });
      } else if (type == "CEN") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          resourceList: item
        };
        this.$api.resourcePermis.createAliCenRelation(_data).then(res => {
          this.$Message.success("添加成功");
          this.addCENVisible = false;
          this.getCENData();
        });
      } else if (type == "ElasticIp") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          resourceList: item
        };
        this.$api.resourcePermis.createElasticIP(_data).then(res => {
          this.$Message.success("添加成功");
          this.addElasticIpVisible = false;
          this.getElasticIpData();
        });
      } else if (type == "Autoscaling") {
        let _data = {
          groupId: this.$route.query.id,
          accountType: this.searchResourceData.accountType,
          resourceList: item
        };
        this.$api.resourcePermis.createAutoscalings(_data).then(res => {
          this.$Message.success("添加成功");
          this.addAutoscalingVisible = false;
          this.getAutoscalingData();
        });
      }
    },
    // 添加弹窗-点击查询资源
    getAddData(item, value) {
      if (item.flag == "Bucket") {
        if (this.addResourceBucketData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceBucketData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceBucketData.accountIds,
          region: this.addResourceBucketData.region
        };
        this.$api.resourcePermis
          .queryBucketGroupByAccountId(_data)
          .then(res => {
            this.BucketAddTableData = res.data.bucketDTOS;
          });
      } else if (item.flag == "LogService") {
        if (this.addResourceLogServiceData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceLogServiceData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceLogServiceData.accountIds,
          region: this.addResourceLogServiceData.region
        };
        this.$api.resourcePermis.queryLogByAccountId(_data).then(res => {
          this.LogServiceAddTableData = res.data.logDTOS;
        });
      } else if (item.flag == "SLB") {
        if (this.addResourceSLBData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceSLBData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceSLBData.accountIds,
          region: this.addResourceSLBData.region
        };
        this.$api.resourcePermis
          .queryLoadBalancerByAccountId(_data)
          .then(res => {
            this.SLBAddTableData = res.data.loadBalancerDTOS;
          });
      } else if (item.flag == "NatGateway") {
        if (this.addResourceNatGatewayData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceNatGatewayData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceNatGatewayData.accountIds,
          region: this.addResourceNatGatewayData.region
        };
        this.$api.resourcePermis.queryNatGatewayByAccountId(_data).then(res => {
          this.NatGatewayAddTableData = res.data.resourceNatgatewayDTOS;
        });
      } else if (item.flag == "Redshift") {
        if (this.addResourceRedshiftData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceRedshiftData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIdList: this.addResourceRedshiftData.accountIds,
          region: this.addResourceRedshiftData.region
        };
        this.$api.resourcePermis.queryRedshiftByAccountId(_data).then(res => {
          this.RedshiftAddTableData = res.data.clusterDTOS;
        });
      } else if (item.flag == "Elasticsearch") {
        if (this.addResourceElasticsearchData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceElasticsearchData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceElasticsearchData.accountIds,
          region: this.addResourceElasticsearchData.region
        };
        this.$api.resourcePermis.queryEsByAccountId(_data).then(res => {
          this.ElasticsearchAddTableData = res.data.resourceEsDTOS;
        });
      } else if (item.flag == "BackUp") {
        if (this.addResourceBackUpData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceBackUpData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceBackUpData.accountIds,
          region: this.addResourceBackUpData.region
        };
        this.$api.resourcePermis.queryBackupPlanByAccountId(_data).then(res => {
          this.BackUpAddTableData = res.data.backupPlanDTOS;
        });
      } else if (item.flag == "Firewall") {
        if (this.addResourceFirewallData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceFirewallData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceFirewallData.accountIds,
          region: this.addResourceFirewallData.region
        };
        this.$api.resourcePermis
          .queryfirewallAlicenByAccountId(_data)
          .then(res => {
            this.FirewallAddTableData = res.data;
          });
      } else if (item.flag == "CEN") {
        if (this.addResourceCENData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceCENData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceCENData.accountIds,
          region: this.addResourceCENData.region
        };
        this.$api.resourcePermis.queryCENAlicenByAccountId(_data).then(res => {
          this.CENAddTableData = res.data;
        });
      } else if (item.flag == "ElasticIp") {
        if (this.addResourceElasticIpData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceElasticIpData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceElasticIpData.accountIds,
          region: this.addResourceElasticIpData.region
        };
        this.$api.resourcePermis.queryEipsByAccountId(_data).then(res => {
          this.ElasticIpAddTableData = res.data;
        });
      } else if (item.flag == "Autoscaling") {
        if (this.addResourceAutoscalingData.accountIds.length == 0) {
          this.$Message.error("请选择账户名称");
          return;
        }
        if (!this.addResourceAutoscalingData.region) {
          this.$Message.error("请选择区域");
          return;
        }
        let _data = {
          groupId: this.$route.query.id,
          accountIds: this.addResourceAutoscalingData.accountIds,
          region: this.addResourceAutoscalingData.region
        };
        this.$api.resourcePermis
          .queryAutoscalingsByAccountId(_data)
          .then(res => {
            this.AutoscalingAddTableData = res.data.AutoscalingPlanDTOS;
          });
      }
    },
    // 添加弹窗-选择账户数据
    handleChangeAccount(item, value) {
      this.getAccountId = value;
      if (item.flag == "Bucket") {
        this.addResourceBucketData.accountIds = value;
      } else if (item.flag == "LogService") {
        this.addResourceLogServiceData.accountIds = value;
      } else if (item.flag == "SLB") {
        this.addResourceSLBData.accountIds = value;
      } else if (item.flag == "NatGateway") {
        this.addResourceNatGatewayData.accountIds = value;
      } else if (item.flag == "Redshift") {
        this.addResourceRedshiftData.accountIds = value;
      } else if (item.flag == "Elasticsearch") {
        this.addResourceElasticsearchData.accountIds = value;
      } else if (item.flag == "BackUp") {
        this.addResourceBackUpData.accountIds = value;
      } else if (item.flag == "Firewall") {
        this.addResourceFirewallData.accountIds = value;
      } else if (item.flag == "CEN") {
        this.addResourceCENData.accountIds = value;
      } else if (item.flag == "ElasticIp") {
        this.addResourceElasticIpData.accountIds = value;
      } else if (item.flag == "Autoscaling") {
        this.addResourceAutoscalingData.accountIds = value;
      }
    },
    // 添加弹窗-选择区域数据
    handleChangeRegion(item, value) {
      if (item.flag == "Bucket") {
        this.addResourceBucketData.region = value;
      } else if (item.flag == "LogService") {
        this.addResourceLogServiceData.region = value;
      } else if (item.flag == "SLB") {
        this.addResourceSLBData.region = value;
      } else if (item.flag == "NatGateway") {
        this.addResourceNatGatewayData.region = value;
      } else if (item.flag == "Redshift") {
        this.addResourceRedshiftData.region = value;
      } else if (item.flag == "Elasticsearch") {
        this.addResourceElasticsearchData.region = value;
      } else if (item.flag == "BackUp") {
        this.addResourceBackUpData.region = value;
      } else if (item.flag == "Firewall") {
        this.addResourceFirewallData.region = value;
      } else if (item.flag == "CEN") {
        this.addResourceCENData.region = value;
      } else if (item.flag == "ElasticIp") {
        this.addResourceElasticIpData.region = value;
      } else if (item.flag == "Autoscaling") {
        this.addResourceAutoscalingData.region = value;
      }
    },
    // 云平台
    queryCloudPlatforms: function() {
      this.$api.account
        .queryCloudPlatforms("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    }
  },
  mounted() {
    this.queryCloudPlatforms();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/resource/resource.vue